import React, { Fragment } from 'react'
import FxIcon from '../Icons/FxIcon'

const FxNavIcon = (props) => {
  return(
    <Fragment>
      <span className={props.width < 480 ? 'small-navFont' : 'navFont'} style={{color:'#00e5ff'}}>
        <span style={{paddingRight:'.25em'}}>
          <FxIcon 
            height={
              props.width < 480 ? '1.3em' : '1.3em'
            } 
            width={
              props.width < 480 ? '1.3em' : '1.3em'
            } 
            fill='#00e5ff'
          />
        </span>
      </span> 
    </Fragment>
  )
}

export default FxNavIcon